import { useState } from "react";
import { useAlert } from "../../../Hooks/useAlert";
import { authAPI } from "../../../services/api";
import Alert from "../../common/Alert";
import ConfirmDialog from "../../common/ConfirmDialog";

function LogoutSection({ text, compact, header }) {
  const { showAlert, showConfirm, alertConfig, confirmConfig } = useAlert();
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    const confirmed = await showConfirm({
      type: "warning",
      title: "Logout",
      message: text.logoutConfirmMessage,
      confirmText: "Logout",
      cancelText: "Cancel",
    });

    if (confirmed) {
      try {
        setLoading(true);
        await authAPI.logout();
        window.location.href = "/login";
      } catch (error) {
        console.error("Logout failed:", error);
        await showAlert({
          type: "error",
          title: "Error",
          message: "Logout failed. Please try again.",
        });
        setLoading(false);
      }
    }
  };

  if (header) {
    return (
      <>
        <button
          type="button"
          disabled={loading}
          className="logout-header-btn"
          onClick={handleLogout}
          title={text.logoutButton}
        >
          <i className="fas fa-sign-out-alt" />
        </button>
        {alertConfig && <Alert {...alertConfig} />}
        {confirmConfig && <ConfirmDialog {...confirmConfig} />}
      </>
    );
  }

  if (compact) {
    return (
      <>
        <button
          type="button"
          disabled={loading}
          className="logout-compact"
          onClick={handleLogout}
        >
          <i className="fas fa-sign-out-alt" />
          <span>{text.logoutButton}</span>
        </button>
        {alertConfig && <Alert {...alertConfig} />}
        {confirmConfig && <ConfirmDialog {...confirmConfig} />}
      </>
    );
  }

  return (
    <section className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl p-4 md:p-5 shadow-sm mt-2">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-base md:text-lg font-bold flex items-center gap-2 md:gap-3 text-slate-900 dark:text-white">
          <i className="fas fa-user-circle text-primary" />
          <span>{text.logoutSectionTitle}</span>
        </h2>
      </div>
      <button
        type="button"
        disabled={loading}
        className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2.5 px-3 rounded-lg flex items-center justify-center gap-2 text-sm transition disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleLogout}
      >
        <i className="fas fa-sign-out-alt" />
        <span>{text.logoutButton}</span>
      </button>

      {alertConfig && <Alert {...alertConfig} />}
      {confirmConfig && <ConfirmDialog {...confirmConfig} />}
    </section>
  );
}

export default LogoutSection;
